<template>
  <el-dialog :title="title" width="400px" :visible.sync="visible" :append-to-body="appendToBody">
    <el-upload
      drag
      action="null"
      class="upload-demo"
      style="text-align: center"
      :http-request="handleUpload"
      :limit="1"
      :file-list="fileList"
      :accept="accept"
    >
      <i class="el-icon-upload" />
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div slot="tip" class="el-upload__tip">( {{ tips }} )</div>
      <div slot="tip" class="el-upload__tip" v-if="enableDownloadTemplate">
        为保证数据导入顺利，推荐您使用:
        <el-link style="font-size: 12px" type="primary" @click="handleDownload"> 下载模板 </el-link>
      </div>
    </el-upload>

  </el-dialog>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: "上传",
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    accept: { 
      type: String,
      required: true,
    },
    api: {
      type: Function,
      required: true,
    },
    enableDownloadTemplate: {
      type: Boolean,
      default: false,
    },
    downloadApi: {
      type: Function,
    },
    tips: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      default: 1,
    },
    uploadSucess: {
      type: Function,
      required: true,
    },
    // handleError: {
    //   type: Function,
    //   required: true,
    // }
  },
  data() {
    return {
      visible: false,
      uploadLoading: false,
      downloadLoading: false,
      fileList: [],
      warnings: [],
      progressPercent: 0,
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.fileList = [];
        this.warnings = [];
      }
    },
  },
  methods: {
    setVisible(val = false) {
      this.visible = val;
    },
    handleUpload(params) {
      console.log({params});
      this.uploadLoading = true;
      this.progressPercent = 0;
      this.api(params, (progressEvent) => {
        this.progressPercent = this.uploadProgressEvent(progressEvent);
      })
        .then((res) => {
          const { data } = res
          if(data.errorMsgs.length > 0) {
            const errInfo = data.errorMsgs.join('; ')
            this.msgError(errInfo);
          }else {
            this.visible = false;
            this.msgSuccess(`导入成功`);
            this.uploadSucess(res);
          }
        })
        .catch((error) => {
          console.log({error});
        })
        .finally(() => {
          this.fileList = [];
          this.uploadLoading = false;
        });
    },
    async handleDownload() {
      this.downloadLoading = true;
      try {
        await this.downloadApi();
      } finally {
        this.downloadLoading = false;
      }
    },
    uploadProgressEvent(progressEvent) {
      return Math.floor((progressEvent.loaded * 100) / progressEvent.total);
    },
    formatter(row) {
      return row;
    },
  },
};
</script>
